module.exports = __webpack_public_path__ + "static/media/home-bg-5.a82ebf43.jpg";